module.exports = __webpack_public_path__ + "fonts/motiva-sans-light.e0ea07d.otf";